import { render, staticRenderFns } from "./SalesReportsOverviewPanel.vue?vue&type=template&id=4db706d4&scoped=true"
import script from "./SalesReportsOverviewPanel.vue?vue&type=script&lang=js"
export * from "./SalesReportsOverviewPanel.vue?vue&type=script&lang=js"
import style0 from "./SalesReportsOverviewPanel.vue?vue&type=style&index=0&id=4db706d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db706d4",
  null
  
)

export default component.exports